/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartAConversationAboutACarRequest
 */
export interface StartAConversationAboutACarRequest {
    /**
     * The <code>id</code> of an existing record in the cars table.
     * @type {number}
     * @memberof StartAConversationAboutACarRequest
     */
    carId: number;
    /**
     * Must not be greater than 5000 characters.
     * @type {string}
     * @memberof StartAConversationAboutACarRequest
     */
    body?: string | null;
}

/**
 * Check if a given object implements the StartAConversationAboutACarRequest interface.
 */
export function instanceOfStartAConversationAboutACarRequest(value: object): value is StartAConversationAboutACarRequest {
    if (!('carId' in value) || value['carId'] === undefined) return false;
    return true;
}

export function StartAConversationAboutACarRequestFromJSON(json: any): StartAConversationAboutACarRequest {
    return StartAConversationAboutACarRequestFromJSONTyped(json, false);
}

export function StartAConversationAboutACarRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartAConversationAboutACarRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'carId': json['car_id'],
        'body': json['body'] == null ? undefined : json['body'],
    };
}

export function StartAConversationAboutACarRequestToJSON(json: any): StartAConversationAboutACarRequest {
    return StartAConversationAboutACarRequestToJSONTyped(json, false);
}

export function StartAConversationAboutACarRequestToJSONTyped(value?: StartAConversationAboutACarRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'car_id': value['carId'],
        'body': value['body'],
    };
}

